import { Flex, Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { FAQ } from '@/widgets/FAQ';
import { headerHeight, metaData } from '@/shared/constants';
import { DefaultContainer } from '@/shared/ui';
import { JsonLdDecorator, MetaDecorator } from '@/shared/utils';
import { benefits } from '../lib/benefits';
import { questions } from '../lib/questions';
import BenefitCard from './BenefitCard';
import PricingWidget, { IPricingWidgetProps } from './PricingWidget';
import StrongSides from './StrongSides';

const BENEFITS_BLOCK_HEADING = 'Complete feature set';

const listItemsJsonLd = [
  {
    heading: BENEFITS_BLOCK_HEADING,
    list: benefits,
  },
];

const PricingPage: FC<IPricingWidgetProps> = ({ tariffs }) => (
  <>
    <MetaDecorator
      description={metaData.pricing.description}
      title={metaData.pricing.title}
    />
    <JsonLdDecorator
      faqList={questions}
      listItems={listItemsJsonLd}
      tariffs={tariffs}
    />

    <DefaultContainer
      alignItems='center'
      mt={headerHeight}
    >
      <Heading
        as='h1'
        textAlign='center'
        w={{ base: 'full', md: '70%' }}
      >
        Simple, transparent pricing for every business
      </Heading>
      <StrongSides />
      <PricingWidget tariffs={tariffs} />
    </DefaultContainer>

    <DefaultContainer gap={{ base: 'md', md: '2xl' }}>
      <Heading textAlign='center'>{BENEFITS_BLOCK_HEADING}</Heading>
      <Flex
        flexWrap='wrap'
        gap='lg'
        justifyContent='center'
      >
        {benefits.map((benefit) => (
          <BenefitCard
            key={benefit.heading}
            {...benefit}
          />
        ))}
      </Flex>
    </DefaultContainer>

    <FAQ questions={questions} />
  </>
);

export default PricingPage;
